/**
 * 无资质展示推荐内容
 * */
import React, { PureComponent } from 'react';
import { withRouter } from '../../WithRouterHOC';
import Util from '../../../script/util';
import HTTP from '../../../script/service';
import { DDEmpty, DDLoading } from '../../globalPageStatus';
import AudioModal from '../../audioModal';
import './OtherDsRecommend.scss';

class OtherDsRecommend extends PureComponent {
  state = {
    loading: false, // 加载中
    hotData: [], // 人气推荐列表
    hotParam: {
      // 人气推荐参数
      page: 0,
      size: 5,
      loading: false,
      more: true,
    },
  };

  componentDidMount() {
    this.getHotData(true);
  }

  //获取人气推荐
  getHotData = (reset) => {
    const { hotParam } = this.state;
    if (!hotParam.more) {
      reset = true;
    }
    if (reset) {
      hotParam.page = 0;
      hotParam.loading = false;
      hotParam.more = true;
      this.setState({
        contentType: 'hot',
        hotParam: hotParam,
        hotData: null,
      });
    }
    if (hotParam.loading) return false;
    if (!hotParam.more) return false;
    hotParam.loading = true;
    hotParam.page += 1;
    hotParam.type = 4;
    this.setState({ loading: true, hotParam: hotParam }, () => {
      HTTP._get_home_recommend_for_pc(hotParam)
        .then((res) => {
          hotParam.loading = false;
          if (res?.code === 200) {
            let hotData = res.data;
            if (res.data.length < hotParam.size) {
              hotParam.more = false;
            }
            this.setState({
              hotParam: hotParam,
              hotData: hotData,
            });
          }
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    });
  };

  //重新打开大神资料
  openUserInfo = (e, item) => {
    e.stopPropagation();
    this.props.openUserInfo({
      dsid: item.uid,
      jnid: item.categoryId,
      ehot: true,
    });
  };

  // 用户在线状态
  renderUserOnlineStatus = (user = null) => {
    if (user?.roomid) {
      return (
        <div
          className="user-status-tag inroom"
          onClick={(e) => this.props.inRoom(e, user.roomid, user.roomName)}
        >
          <span className="icon-audio" />
          <span>正在语聊中</span>
        </div>
      );
    }

    if (user?.ifOnline !== 0) {
      return <div className="user-status-tag online">在线</div>;
    } else {
      return <div className="user-status-tag not-online">离线</div>;
    }
  };

  render() {
    const { loading, hotData } = this.state;
    return (
      <DDLoading status={loading}>
        <div className="other-ds-recommend">
          <div className="other-header">
            <h4 className="title">
              <i className="icon" />
              8元专区陪玩推荐{' '}
            </h4>
            <span className="text" onClick={() => this.getHotData(false)}>
              换一批 <i className="icon" />{' '}
            </span>
          </div>
          <ul className="ds-user-content">
            {hotData?.length
              ? hotData.map((item) => (
                  <li
                    key={item.uid}
                    className="item-ds-user"
                    onClick={(e) => this.openUserInfo(e, item)}
                  >
                    {this.renderUserOnlineStatus(item)}
                    <div className="user-avatar">
                      <img
                        src={Util.transImgUrl(item.headPic, '160x160')}
                        alt={item.nickname}
                      />
                    </div>
                    {item.ifVoice === 1 ? (
                      <div className="other-audio">
                        <AudioModal data={item} />
                      </div>
                    ) : null}
                    <p className="user-nick">{item.nickname}</p>
                  </li>
                ))
              : !loading && <DDEmpty description="没有找到相关内容" />}
          </ul>
        </div>
      </DDLoading>
    );
  }
}

export default withRouter(OtherDsRecommend, { withRef: true });
